<template>
  <div class="container container_40 manage-orders">
    <div class="text_large">{{ i18n.trd_manage({ pair: `${assets.base}/${assets.quote}` }) }}</div>

    <template v-if="offers.length">
      <md-table class="manage-orders__table scrollbar">
        <md-table-row class="manage-orders__row">
          <md-table-head>{{ i18n.trd_manage_date() }}</md-table-head>
          <md-table-head>{{ i18n.trd_manage_market() }}</md-table-head>
          <md-table-head>{{ i18n.trd_manage_order() }}</md-table-head>
          <md-table-head>{{ i18n.trd_manage_base_asset_amount() }}</md-table-head>
          <md-table-head>{{ i18n.trd_manage_quote_asset_price() }}</md-table-head>
        </md-table-row>

        <template v-for="(order, i) in offers">
          <md-table-row class="manage-orders__row" @click="toggleDetails(i)" :key="`${i}-row`">
            <md-table-cell class="text_medium">{{ i18n.d(order.createdAt) }}</md-table-cell>
            <md-table-cell class="text_medium">{{ `${order.baseAssetCode}/${order.quoteAssetCode}` }}
            </md-table-cell>
            <md-table-cell class="text_medium">
              {{ order.isBuy ? i18n.trd_order_buy() : i18n.trd_order_sell() }}
            </md-table-cell>
            <md-table-cell class="text_medium">{{ roundCurrency(order.baseAmount, order.baseAssetCode)
              }}
            </md-table-cell>
            <md-table-cell class="text_medium">{{ roundCurrency(order.price, order.quoteAssetCode) }}
            </md-table-cell>
            <md-table-cell>
              <md-button class="manage-orders__open-details-btn md-icon-button">
                <md-icon v-if="isSelected(i)">keyboard_arrow_up</md-icon>
                <md-icon v-else>keyboard_arrow_down</md-icon>
              </md-button>
            </md-table-cell>

          </md-table-row>

          <md-table-row class="manage-orders__expandable-row" v-if="isSelected(i)" :key="`${i}-expand`">
            <md-table-cell colspan="7">
              <order-details class="manage-orders__details" :tx="order"/>
            </md-table-cell>
          </md-table-row>
        </template>
      </md-table>
    </template>

    <template v-else>
      <div class="container__no-data">
        <md-icon class="md-size-4x">trending_up</md-icon>
        <div class="text_large">{{ i18n.trd_no_orders_history() }}</div>
        <div class="text_description text_margin text_medium">{{ i18n.trd_here_will_be_the_order_list() }}</div>
      </div>
    </template>

  </div>
</template>

<script>
  import OrderDetails from './ManageOrders.OrderDetails'
  import { i18n } from '@js/i18n'
  import CurrencyRound from '@com/mixins/currency.round.mixin'

  export default {
    name: 'manage-orders',
    mixins: [CurrencyRound],
    components: { OrderDetails },
    props: {
      offers: { type: Array, require: true },
      assets: { type: Object, retuqire: true }
    },
    data () {
      return {
        index: -1,
        i18n
      }
    },
    methods: {
      toggleDetails (index) {
        this.index = this.index === index ? -1 : index
      },
      isSelected (i) {
        return this.index === i
      }
    },
    watch: {

    }
  }
</script>

<style lang="scss" scoped>
  .manage-orders__details {
    max-width: 400px;
  }
  .manage-orders__row {
    cursor: pointer;
  }

  .manage-orders__table {
   margin-top: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/trade/index/components/manageOrders/Trade.ManageOrders.vue